/*
 * @Author: lc
 * @Date: 2022-07-31 09:28:43
 * @LastEditors: lc
 * @LastEditTime: 2022-07-31 09:36:28
 * @Description: 
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const exchange = {
    // 列表
    list (params) {
        return axios.get(api + 'exchange/list', { params: params })
    },
}


// 导出接口
export default exchange
